import { useDpHidden } from '@/components/blocks/DpLibrary/DpHiddenForDay';
import { Img } from '@/components/blocks/MaterialImage';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { combineSX } from '@/utils/combineSX';
import { formatHref } from '@/utils/formatHref';
import { Box, Dialog, IconButton, SxProps } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { FC } from 'react';

interface Props {
	src: string;
	alt?: string;
	href?: string;
	sxframe?: SxProps;
	sximg?: SxProps;
	sxbutton?: SxProps;
	/** Unique identifier for localStorage key */
	id?: string;
	/** Display mode: 'one_show' shows only once ever, 'day_show' shows once per day */
	mode?: 'one_show' | 'day_show';
}

export const DpPopUpPromotion: FC<Props> = ({
	src,
	alt = 'Dp promotion',
	href,
	sximg,
	sxbutton,
	sxframe,
	id = 'popup_promotion',
	mode = 'day_show',
}) => {
	const router = useNextRouter();
	const { showComponent, hideComponent } = useDpHidden({
		id,
		mode,
		autoHidden: false,
	});

	if (!showComponent) {
		return null;
	}

	const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		hideComponent();
	};

	const handlePush = (event: any) => {
		event.stopPropagation();
		const _href = href ? formatHref(href) : undefined;
		if (_href) {
			router.push(_href);
		}
	};

	return (
		<Dialog
			sx={{
				zIndex: 8999,
			}}
			open={showComponent}
			onClose={handleClose}
		>
			<Box
				sx={combineSX([
					{ position: 'relative', cursor: href ? 'pointer' : 'default' },
					...(Array.isArray(sxframe) ? sxframe : [sxframe]),
				])}
				onClick={handlePush}
			>
				<IconButton
					onClick={handleClose}
					sx={combineSX([
						{
							backgroundColor: '#000000',
							position: 'absolute',
							right: '15px',
							top: '15px',
							'&:hover': {
								backgroundColor: '#000000',
							},
						},
						...(Array.isArray(sxbutton) ? sxbutton : [sxbutton]),
					])}
				>
					<ClearIcon sx={{ color: 'white' }} fontSize="inherit" />
				</IconButton>

				<Img
					sx={combineSX([
						{ width: { xs: '300px', md: '400px' } },
						...(Array.isArray(sximg) ? sximg : [sximg]),
					])}
					src={src}
					alt={alt}
				/>
			</Box>
		</Dialog>
	);
};
